import displayInfoContainer from "../components/infoContainer";
import StoreUser from "../entities/StoreUser";
import addUserNameToNavBar from "../helpers/addUserNameToNavBar";
import returnHome from "../helpers/returnHome";
import registerView from "../views/registerView";
export function registerViewLogic(store, mainContent) {
    viewRendering(mainContent);
    registerFormEvents(store);
}
//view rendering
function viewRendering(mainContent) {
    mainContent.innerHTML = registerView();
}
//Sign up for events
function registerFormEvents(store) {
    var registerForm = document.getElementById("form");
    registerForm["submit-button"].addEventListener("click", function () {
        try {
            var newUser = new StoreUser();
            verifyInputData(newUser, registerForm);
            store.registerUser(newUser);
            addUserNameToNavBar(newUser.firstName.toUpperCase());
            displayInfoContainer("El usuario ha sido creado correctamente.");
            returnHome();
        }
        catch (error) {
            displayInfoContainer("" + error);
        }
    });
}
//verify user creation according to UserStore Class rules
function verifyInputData(newUser, registerForm) {
    newUser.firstName = registerForm["first-name"].value;
    newUser.lastName = registerForm["last-name"].value;
    newUser.mailAdress = registerForm["mail-adress"].value;
    if (registerForm["password"].value != registerForm["password-repeat"].value) {
        throw Error("El campo 'Contraseña' y 'Repetir contraseña' no coinciden.");
    }
    else {
        newUser.password = registerForm["password"].value;
    }
}
